import { useState, useEffect } from "react";

const useDeviceType = () => {
  const [deviceType, setDeviceType] = useState("desktop");

  useEffect(() => {
    const updateDeviceType = () => {
      const width = window.innerWidth;
      if (width < 640) setDeviceType("mobile");
      else if (width >= 640 && width < 1024) setDeviceType("tablet");
      else if (width >= 1024 && width < 1280) setDeviceType("laptop");
      else if (width >= 1280 && width < 1400) setDeviceType("laptop-xl");
      else if (width >= 1400 && width < 1920) setDeviceType("laptop-2xl");
      else setDeviceType("desktop");
    };

    updateDeviceType();
    window.addEventListener("resize", updateDeviceType);
    return () => window.removeEventListener("resize", updateDeviceType);
  }, []);

  return deviceType;
};

export default useDeviceType;
